import React from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#1f2328',
        color: '#fff',
        borderTop: '1px solid rgba(255,255,255,0.08)',
        py: { xs: 4, md: 5 },
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={2.5} alignItems="center" textAlign="center">
          <Box
            component="img"
            src="/logo-white.png?v=20260611"
            alt="IDECONECTA"
            sx={{
              width: { xs: 180, md: 240 },
              maxWidth: '70vw',
              height: 'auto',
              objectFit: 'contain',
            }}
          />

          <Typography sx={{ fontWeight: 700, fontSize: { xs: '1rem', md: '1.12rem' }, color: '#fff' }}>
            Uma comunidade de empresários que compram, vendem e crescem juntos.
          </Typography>

          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.58)' }}>
            © {new Date().getFullYear()} IDEBRASIL. Todos os direitos reservados.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
